module.exports = __webpack_public_path__ + "static/media/YF45_5.ce36aa4d.jpg";